import React from 'react';
import { FaBackspace } from 'react-icons/fa';
import styles from './Keypad.module.css';

const Keypad = ({ onInput, onClear, onBackspace, onQuickAdd }) => {
  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0'];

  return (
    <div className={styles.keypadContainer}>
      <div className={styles.quickAddButtons}>
        <button onClick={() => onQuickAdd(5000)}>+ ₹5,000</button>
        <button onClick={() => onQuickAdd(10000)}>+ ₹10,000</button>
        <button onClick={() => onQuickAdd(30000)}>+ ₹30,000</button>
      </div>
      <div className={styles.keypadGrid}>
        {keys.map(key => (
          <button key={key} onClick={() => onInput(key)} className={styles.keypadButton}>
            {key}
          </button>
        ))}
        <button onClick={onBackspace} className={styles.keypadButton}>
          <FaBackspace />
        </button>
      </div>
    </div>
  );
};

export default Keypad;
